import React from "react";
import { CustomForm, CustomInput, CustomTextArea } from "../../shared/Input/AllInputs";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import OurClientContainer from "./OurClientContainer";

const OurClientForm = ({ type }) => {
    const { data, handleChange, loading, onSubmit } = OurClientContainer();

    return (
        <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
            <CustomInput label="Title" name="title" data={data} onChange={handleChange} disabled={type === "VIEW"} />
            <CustomTextArea label="Description" name="description" data={data} onChange={handleChange} disabled={type === "VIEW"} />
            <h5 className="m-0 col-11">Auther</h5>
            <CustomImageInput name="image" label="Author Image" key="image" data={data} editable={true} onFilesChange={handleChange} />
            <CustomInput label="Name" name="name" data={data} onChange={handleChange} disabled={type === "VIEW"} />
            <CustomInput
                label="Role"
                name="role"
                data={data}
                onChange={handleChange}
                disabled={type === "VIEW"}
            />
            {type !== "VIEW" && <PrimaryButton label="Save Client" loading={loading} onClick={onSubmit} col={6} />}
        </CustomForm>
    );
};

export default OurClientForm;
